(() => {
  const root = document.querySelector('#store-lp');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const cdn = 'https://cdn.shopify.com/s/files/1/0687/0610/7614/files/';
  const stores = {
    yaesu: {
      name: '東京ミッドタウン八重洲店',
      station: '東京駅 地下直結 ｜ 11:00-21:00',
      address: '東京都中央区八重洲二丁目2番1号\n東京ミッドタウン八重洲2階',
      hours: '11:00-21:00',
      access: 'JR・丸の内線「東京」駅 地下直結（八重洲地下街経由）\n銀座線「京橋」駅 徒歩3分\n東西線・銀座線・浅草線「日本橋」駅 徒歩6分',
      beds: 'シングル5台', mattress: '3種',
      course: 'このコースで予約する（八重洲）',
      photo: cdn + 'lp_store_ad_img01.webp',
      product: cdn + 'lp_store_ad_yaesu.webp',
      reservation: 'https://frm.rsv-site.owl-solution.jp/kCla6p3IgY'
    },
    umeda: {
      name: '阪神梅田本店',
      station: '大阪梅田駅 徒歩約1分 ｜ 10:00-20:00',
      address: '大阪府大阪市北区梅田1丁目13番13号\n阪神梅田本店8F',
      hours: '10:00-20:00',
      access: '阪神「大阪梅田」駅 徒歩約1分\nJR「大阪」駅 徒歩約2分\n御堂筋線「梅田」駅 徒歩約1分\n谷町線「東梅田」駅 徒歩約1分',
      beds: 'シングル2台', mattress: '2種',
      course: 'このコースで予約する（阪神梅田）',
      photo: cdn + 'lp_store_ad_img01_osaka_v2.webp',
      product: cdn + 'lp_store_ad_umeda.webp',
      reservation: 'https://frm.rsv-site.owl-solution.jp/CB0tIQdkMQ'
    }
  };
  const tabs = [...root.querySelectorAll('[data-store]')];
  const dock = root.querySelector('.sl-sticky-switch');
  const picker = root.querySelector('.sl-store-picker');
  const nav = root.querySelector('.sl-page-nav');
  const navLinks = [...nav.querySelectorAll('a')];
  const header = document.querySelector('.section-header');
  let frame = 0;
  let followUntil = 0;

  function select(key) {
    const data = stores[key];
    if (!data) return;
    root.dataset.selectedStore = key;
    root.querySelector('#sl-store-panel').setAttribute('aria-labelledby', 'sl-tab-' + key);
    tabs.forEach(tab => {
      const active = tab.dataset.store === key;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active && (!dock.contains(tab) || dock.classList.contains('is-visible')) ? 0 : -1;
    });
    root.querySelectorAll('[data-field]').forEach(el => {
      el.textContent = el.dataset.field === 'holiday' ? '施設の休館日に準ずる' : data[el.dataset.field];
      el.style.whiteSpace = 'pre-line';
    });
    root.querySelectorAll('[data-yaesu-only]').forEach(el => { el.hidden = key !== 'yaesu'; });
    root.querySelectorAll('[data-navigator-link]').forEach(el => { el.href = data.reservation; });
    const photo = root.querySelector('#sl-store-photo');
    photo.src = data.photo;
    photo.height = key === 'umeda' ? 377 : 378;
    photo.alt = data.name + 'の外観';
    const products = root.querySelector('#sl-products-photo');
    products.src = data.product;
    products.alt = data.name + 'の寝具お試しスペース';
    const query = encodeURIComponent('ブレインスリープ ' + data.name);
    root.querySelector('#sl-map').src = 'https://maps.google.com/maps?q=' + query + '&output=embed';
    root.querySelector('#sl-route').href = 'https://www.google.com/maps/dir/?api=1&destination=' + query;
    schedule();
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => select(tab.dataset.store));
    tab.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const group = [...tab.closest('[role=tablist]').querySelectorAll('[data-store]')];
      const next = event.key === 'Home' ? group[0] : event.key === 'End' ? group[1] : group.find(el => el !== tab);
      next.focus();
      select(next.dataset.store);
    });
  });

  root.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', event => {
      const hash = link.getAttribute('href');
      if (hash === '#') return;
      const target = root.querySelector(hash);
      if (!target) return;
      event.preventDefault();
      const headerBottom = header && ['sticky', 'fixed'].includes(getComputedStyle(header).position)
        ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const willShowDock = target.getBoundingClientRect().top >= picker.getBoundingClientRect().bottom;
      const dockHeight = willShowDock ? dock.firstElementChild.getBoundingClientRect().height : 0;
      root.style.setProperty('--sl-anchor-offset', (headerBottom + nav.getBoundingClientRect().height + dockHeight + 12) + 'px');
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  });

  function updateSticky() {
    frame = 0;
    let headerBottom = 0;
    if (header && ['sticky', 'fixed'].includes(getComputedStyle(header).position)) {
      headerBottom = Math.max(0, header.getBoundingClientRect().bottom);
    }
    const navHeight = nav.getBoundingClientRect().height;
    root.style.setProperty('--sl-header-offset', headerBottom + 'px');
    const visible = picker.querySelector('.sl-tabs').getBoundingClientRect().top <= nav.getBoundingClientRect().bottom;
    dock.classList.toggle('is-visible', visible);
    dock.setAttribute('aria-hidden', String(!visible));
    dock.querySelectorAll('[data-store]').forEach(tab => {
      tab.tabIndex = visible && tab.dataset.store === root.dataset.selectedStore ? 0 : -1;
    });
    const offset = headerBottom + navHeight + (visible ? dock.firstElementChild.getBoundingClientRect().height : 0);
    root.style.setProperty('--sl-anchor-offset', (offset + 12) + 'px');
    let active = navLinks[0];
    navLinks.forEach(link => {
      const target = root.querySelector(link.getAttribute('href'));
      if (target && target.getBoundingClientRect().top <= offset + Math.min(120, window.innerHeight * 0.2)) active = link;
    });
    navLinks.forEach(link => {
      link.classList.toggle('active', link === active);
      if (link === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    if (performance.now() < followUntil) frame = requestAnimationFrame(updateSticky);
  }

  function schedule() {
    followUntil = performance.now() + 220;
    if (!frame) frame = requestAnimationFrame(updateSticky);
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
  if (header) new MutationObserver(schedule).observe(header, { attributes: true, attributeFilter: ['class'] });
  new ResizeObserver(schedule).observe(nav);
  select('yaesu');
})();
